// ======================================================================
// File: departmentService.js
// Module: PPE → Procurement → Purchase Request
//
// Purpose:
// - Fetch department master list for dropdown
// - Uses NEW PPE-specific department lookup API
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow/master";

const departmentService = {

  getDepartments() {
    return axiosClient.get(`${BASE_URL}/departments`);
  }

};

export default departmentService;
